import { Link } from "react-router-dom";
import { allAnime, featuredAnimeIds } from "@/mocks/animeData";

export default function FeaturedAnime() {
  const featured = allAnime.filter((a) => featuredAnimeIds.includes(a.id));

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            <a href="#featured">精选推荐</a>
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            编辑精选，不可错过的优质动漫
          </p>
        </div>
        <Link
          to="/category/rexue"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
        {featured.map((anime) => (
          <Link
            key={anime.id}
            to={`/article/${anime.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
              <img
                src={anime.cover}
                alt={anime.title}
                title={`${anime.title} - 奶水动漫在线高清观看`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                {anime.score}
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3">
                <p className="text-xs text-white/80">{anime.episodes}</p>
              </div>
            </div>
            <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
              {anime.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-0.5">{anime.updateInfo}</p>
          </Link>
        ))}
      </div>

      <div className="mt-6 text-center sm:hidden">
        <Link
          to="/category/rexue"
          className="inline-flex items-center gap-1 text-sm text-primary-500 cursor-pointer whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}